//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import trackingParamsSwitchAutofillTemplate from '@partials/tracking-params/tracking-params-switch-autofill.html';

import _ from "js/underscore-mixins";

(function() {
  const curalate = angular.module('curalate');

  curalate.component('trackingParamsSwitchAutofill', {
    bindings: {
      paramGroupId: '<',
      params: '=',
      dropdownClass: '@',
      permissionsNeeded: '@',
    },
    template: trackingParamsSwitchAutofillTemplate,
    controller: [
      '$element',
      '$scope',
      '$rootScope',
      'SessionVarsService',
      'TrackingParamsService',
      function(
                $element,
                $scope,
                $rootScope,
                SessionVarsService,
                TrackingParamsService,
            ) {
        const self = this;

        self.hasConfigurePermission = TrackingParamsService.hasConfigurePermission;
        self.hasOverridePermission = TrackingParamsService.hasOverridePermission;

        const MULTIPLE_OPTION_LABEL = 'Multiple (Please Select One)';
        const MULTIPLE_OPTION_VALUE = 'multiple';
        const NONE_OPTION_LABEL = 'None';
        const NONE_OPTION_VALUE = 'none';
        self.autofillParamOptions = [];
        self.multipleAutofillParametersEnabled = true;
        self.multipleAutofillParametersPresent = false;
        self.autoFillParameterNames = [];
        self.disableSelection = false;

        self.isPromotedPostsEnabled = SessionVarsService.isFeatureEnabled('promoted_posts');

                // Only allow selections that are in the current parameter set
        self.autoFillParameterStandardOptions = [{ name: NONE_OPTION_LABEL, value: NONE_OPTION_VALUE }];
        _(self.params).each((param) => {
          const labelName = TrackingParamsService.getLabelForGoogleValue(param.name);
          self.autoFillParameterStandardOptions.push({ name: labelName, value: param.name });
        });

        const setAutofillParamOptions = function(curalateReservedParameter) {
                    // Get the standard options and remove any options that overlap with the reserved parameter (only one)
          self.autofillParamOptions = angular.copy(self.autoFillParameterStandardOptions);
          if (curalateReservedParameter && curalateReservedParameter !== 'none') {
            self.autofillParamOptions = _(self.autofillParamOptions).filter(option => option.value !== curalateReservedParameter);
          }
          if (self.multipleAutofillParametersPresent && self.multipleAutofillParametersEnabled) {
            self.autofillParamOptions.push({ name: MULTIPLE_OPTION_LABEL, value: MULTIPLE_OPTION_VALUE });
          }
          self.disableSelection = self.autofillParamOptions.length <= 1;
        };

                //
                // Legacy customers can have multiple auto-fill parameters, so add in support explicitly where
                // "multiple" will be used as a placeholder if multiple are used. All the values will still be
                // stored and "multiple" will disappear as an option if the "reserved" parameter is changed to
                // overlap with one of the stored "multiple" values. There is only a handful of customers in this
                // state so it is won't be common.
                //
        const autoFillParameters = _.where(self.params, { autoSet: true });
        self.autoFillParameterNames = _.pluck(autoFillParameters, 'name');
        const autoFillParametersSize = _.size(autoFillParameters);
        self.multipleAutofillParametersPresent = autoFillParametersSize > 1;

                // Setup the initial options (these can dynamically depending on the autoFill parameters selected too)
        const curalateReservedParameter = _.findWhere(self.params, { curalateReserved: true });
        if (curalateReservedParameter) {
          setAutofillParamOptions(curalateReservedParameter.name);
        } else {
          setAutofillParamOptions();
        }

                // This is normally a single value, except in the special case legacy "multiple" values case
                // so it is always stored as an array of values
        if (autoFillParametersSize > 1) {
          self.uiValue = MULTIPLE_OPTION_VALUE;
          self.selectedValues = angular.copy(self.autoFillParameterNames);
        } else if (autoFillParametersSize === 1) {
          self.uiValue = autoFillParameters[0].name;
          self.selectedValues = [autoFillParameters[0].name];
        } else {
          self.uiValue = NONE_OPTION_VALUE;
          self.selectedValues = [NONE_OPTION_VALUE];
        }
        self.previousSelectedValues = [];

        self.changeAutofillOption = function(value) {
          if (self.uiValue !== value) {
            self.uiValue = value;
            self.previousSelectedValues = self.selectedValues;
            if (value === MULTIPLE_OPTION_VALUE) {
              self.selectedValues = angular.copy(self.autoFillParameterNames);
            } else {
              self.selectedValues = [value];
            }
            $rootScope.$broadcast('trackingParams:changeAutofillOption', {
              currentValues: self.selectedValues,
              previousValues: self.previousSelectedValues,
            });
          }
        };

                /*
                 * The autoFill select box should not allow the reserved item to be selected
                 */
        $scope.$on('trackingParams:changeReservedOption', (event, data) => {
          if (self.multipleAutofillParametersEnabled) {
            self.multipleAutofillParametersEnabled = (self.autoFillParameterNames.indexOf(data.currentValue) < 0);
          }
          setAutofillParamOptions(data.currentValue);
          _.defer(() => $scope.$apply());
        });

        self.hasCorrectPermissions = function() {
          return self.hasConfigurePermission || (self.permissionsNeeded === 'tracking_parameters:override' && self.hasOverridePermission);
        };
      },
    ],
  });
})();
